export default class AboutAnimation {
    static init(): void {
        const items = document.querySelectorAll<HTMLDivElement>('.js-about-grid-item');
        if (!items.length) return;

        const handleResponsiveBehavior = () => {
            const breakpoint = 991;
        
            // Handle click for toggling active state
            const handleClick = (item: HTMLDivElement) => {
                const isActive = item.classList.contains('is-active');
                items.forEach((el) => el.classList.remove('is-active')); // Remove from all
                if (!isActive) {
                    item.classList.add('is-active'); // Add only if it was not active
                }
            };
        
            // Add hover listeners
            const addHoverListeners = () => {
                items.forEach((item) => {
                    item.addEventListener('mouseenter', () => {
                        item.classList.add('is-active');
                    });
                    item.addEventListener('mouseleave', () => {
                        item.classList.remove('is-active');
                    });
                });
            };
        
            // Add click listeners
            const addClickListeners = () => {
                items.forEach((item) => {
                    item.addEventListener('click', () => handleClick(item));
                });
            };
        
            // Update listeners based on window size
            const updateListeners = () => {
                const windowWidth = window.innerWidth;
        
                // Clear all active classes on resize
                items.forEach((item) => item.classList.remove('is-active'));
        
                // Add appropriate listeners
                if (windowWidth > breakpoint) {
                    addHoverListeners();
                } else {
                    addClickListeners();
                }
            };
        
            // Initialize
            updateListeners();
        
            // Reapply listeners on window resize
            window.addEventListener('resize', updateListeners);
        };
        
        // Initialize the behavior immediately
        handleResponsiveBehavior();
        
    }
}
